import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GuestRegEmailVerifyOTPUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.guestRegEmailVerifyOTP(req);
    }
}
export default GuestRegEmailVerifyOTPUseCase;
